import React from 'react';
import classNames from 'classnames';
import { Arrow } from '@components/common';
import styles from './index.less';
import { tid } from '@utils/test';

const LESS_THAN_000_1 = ' < 0.001';
const GREATER_THAN_1000 = ' > 1000';

function getDisplayedValue(value, precision = 1) {
  const multiplier = 10 ** precision;
  const mul = Math.round(Math.abs(value) * 100 * multiplier) / multiplier;
  if (mul < 0.001) {
    return LESS_THAN_000_1;
  }
  if (mul > 1000) {
    return GREATER_THAN_1000;
  }
  return `${mul}`;
}

const getNoChangeText = (className) => {
  const classString = classNames(styles.trend, className);
  return (
    <div className={classString}>
      <span>-</span>
    </div>
  );
};

const Trend = ({ value, reverse, className, precision, style = {} }) => {
  if (value === null || isNaN(value)) {
    return getNoChangeText(className);
  }

  const displayValue = `${getDisplayedValue(value, precision)}`;
  if (displayValue == LESS_THAN_000_1) {
    return getNoChangeText(className);
  }

  const flag = value < 0 ? 'down' : 'up';
  const type = (flag === 'up' && !reverse) || (flag === 'down' && reverse) ? 'up' : 'down';

  const classString = classNames(styles[type], styles.trend, className);
  const trendStyle = { ...style };
  return (
    <div className={classString} style={trendStyle} {...tid(`trend-${flag}`)}>
      <span>{`${displayValue}%`}</span>
      <Arrow green={type === 'up'} up={value >= 0} />
    </div>
  );
};

Trend.defaultProps = {
  value: '-',
  reverse: false,
  className: '',
  precision: 1,
};

export default Trend;
